module.exports = __webpack_public_path__ + "static/media/permissions.2405d68f.webm";